import { jsx as _jsx } from "react/jsx-runtime";
import { useEstimationResult } from '@estimation/entities/estimationSolution';
import { AlertDialog } from '@shared-app/ui';
import { useTranslation } from 'react-i18next';
export function NoSolutionDialogue() {
    const { t } = useTranslation();
    const { toggleNoSolutionModalVisibility, isNoSolutionModalVisible } = useEstimationResult();
    return (_jsx(AlertDialog, { open: isNoSolutionModalVisible, handleClose: () => toggleNoSolutionModalVisibility(false), title: t('No closest solution found'), details: t('Currently, we couldn’t find any close solutions for your input. We are working to expand our dataset and will have more solutions available soon.'), buttonText: t('OK'), hasSecondaryActionButton: false, onClick: () => toggleNoSolutionModalVisibility(false) }));
}
